// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--3xth1","container":"styles-module--container--eeZmj","image":"styles-module--image--UtGmh","text":"styles-module--text--2OOiI"};